import { useParams } from 'react-router-dom';

import { GetAllJobs } from '@/api/fe-api/view/queries/capacity-evalution/get-all-jobs';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { Tooltip } from '@/components/ui/tooltip';
import { useMe } from '@/hooks/use-me';
import { cls } from '@/utils/cls';
import { formatEnergy } from '@/utils/format/battery';
import { formatDate } from '@/utils/format/date';
import { formatPercentage } from '@/utils/format/number';

import { getStatusColor } from '../get-status-color';

import { CapacityTestStatusIcon } from './capacity-test-status-icon';

export type CapacityTestTableProps = {
  selectedId: string | undefined;
  setSelectedId: (itemId: string) => void;
};

export function CapacityTestTable({
  selectedId,
  setSelectedId,
}: CapacityTestTableProps) {
  const { config } = useMe();
  const { siteId } = useParams<{ siteId: string }>();

  const jobList = GetAllJobs.useQuery({ siteId });

  if (jobList.data?.length === 0) {
    return (
      <p className="flex h-24 items-center justify-center rounded border border-dashed border-zinc-400/20 text-center italic text-zinc-500">
        No capacity tests found
      </p>
    );
  }

  return (
    <Table className="rounded border border-zinc-400/20">
      <TableHead className="sticky top-0 z-10 rounded-t bg-zinc-50 ring-1 ring-zinc-400/20">
        <TableRow>
          <TableHeader>&nbsp;</TableHeader>
          <TableHeader>Analysis Date</TableHeader>
          <TableHeader className="text-right">SOH-C</TableHeader>
          <TableHeader className="max-w-24 whitespace-normal text-right">
            Discharged Energy
          </TableHeader>
        </TableRow>
      </TableHead>
      <TableBody>
        {jobList.data?.map((item) => (
          <TableRow
            key={item.id}
            className={cls('cursor-pointer', {
              'border-l-4 border-primary-500 bg-primary-50':
                selectedId === item.id,
            })}
            onClick={() => setSelectedId(item.id)}
          >
            <TableCell className="!px-2">
              <Tooltip content={item.status}>
                <CapacityTestStatusIcon
                  statusColor={getStatusColor(item.status)}
                />
              </Tooltip>
            </TableCell>
            <TableCell>{formatDate(item.createdAt)}</TableCell>
            <TableCell className="text-right">
              {formatPercentage(item.sohc, 1)}
            </TableCell>
            <TableCell className="text-right">
              {formatEnergy(item.dischargedEnergy, config.powerUnit, 0)}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
